(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6133],{

/***/ 12878:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ state_of_personalization_report; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/templates/Navigation/index.ts + 91 modules
var Navigation = __webpack_require__(87303);
// EXTERNAL MODULE: ../../libs/templates/FooterCompact/index.ts + 2 modules
var FooterCompact = __webpack_require__(69524);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var recipes_Hero = __webpack_require__(84629);
// EXTERNAL MODULE: ../../libs/templates/Forms/EmailCaptureForm/index.ts + 3 modules
var EmailCaptureForm = __webpack_require__(41948);
// EXTERNAL MODULE: ../../libs/utils/useScrollToAnchor/index.ts
var useScrollToAnchor = __webpack_require__(68714);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2023/components/Hero/assets/Hero@2x.png
var Hero_2x = __webpack_require__(49767);
var Hero_2x_default = /*#__PURE__*/__webpack_require__.n(Hero_2x);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2023/components/Hero/assets/Hero.webp
var assets_Hero = __webpack_require__(20799);
var Hero_default = /*#__PURE__*/__webpack_require__.n(assets_Hero);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2023/components/Hero/assets/Hero@2x.webp
var assets_Hero_2x = __webpack_require__(79044);
var assets_Hero_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Hero_2x);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2023/components/Hero/Hero.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }













var copy = {
  heading: "The State of Personalization Report 2023",
  description: "By Twilio Segment"
};
var Hero_form = {
  formId: "state-of-personalization-report-2023",
  additionalTrackEvent: "Content Downloaded",
  buttonText: "Get the full report",
  successButtonText: "Download the report",
  buttonUrl: "https://segment.com/pdfs/State-of-Personalization-Report-Twilio-Segment-2023.pdf"
};
var cta = {
  text: "Talk to a Segment expert"
};

var Hero = function Hero() {
  var _useState = (0,react.useState)(false),
      isFormSubmitted = _useState[0],
      setIsFormSubmitted = _useState[1];

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledHeroBase, {
      variant: "2Col",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Hero/* Copy */.CK, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          variant: "h1",
          tag: "h1",
          children: copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          variant: "pExtraLarge",
          tag: "p",
          children: copy.description
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroForm, {
          variant: isFormSubmitted ? "wide" : "narrow",
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmailCaptureForm/* default */.Z, {
            customFormIdentifier: Hero_form.formId,
            additionalTrackEvent: Hero_form.additionalTrackEvent,
            resourceType: "report",
            buttonText: Hero_form.buttonText,
            successButtonText: Hero_form.successButtonText,
            buttonUrl: Hero_form.buttonUrl,
            onSubmit: function onSubmit() {
              return setIsFormSubmitted(true);
            },
            enableJobTitleField: true
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroCta, {
          onClick: function onClick() {
            return (0,useScrollToAnchor/* scrollToAnchor */.d)("get-most-out-of-customer-data");
          },
          iconEnd: Common/* ChevronRightIcon */.XC,
          children: cta.text
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
            type: "image/webp",
            srcSet: "".concat((Hero_default()), ", ").concat((assets_Hero_2x_default()), " 2x")
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Image */.Ee, {
            width: "640",
            height: "480",
            src: (Hero_2x_default()),
            alt: "Illustration: ".concat(copy.heading)
          })]
        })
      })]
    })
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "evfy5su3"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.green[10];
}, ";" + ( true ? "" : 0));

var StyledHeroBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Hero/* default */.ZP,  true ? {
  target: "evfy5su2"
} : 0)(recipes_Hero/* Copy */.CK, "{text-align:left;}" + ( true ? "" : 0));

var HeroForm = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Hero/* Form */.l0,  true ? {
  target: "evfy5su1"
} : 0)("max-width:", function (_ref2) {
  var variant = _ref2.variant;
  return variant === "narrow" ? "417px" : "unset";
}, ";" + ( true ? "" : 0));

var HeroCta = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ButtonText/* default */.Z,  true ? {
  target: "evfy5su0"
} : 0)( true ? {
  name: "yz1nei",
  styles: "margin-top:16px"
} : 0);

/* harmony default export */ var Hero_Hero = (Hero);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2023/components/Introduction/Introduction.tsx


function Introduction_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





var Introduction_copy = {
  heading: "Welcome to the fourth annual State of Personalization report, our yearly deep-dive into the latest trends in personalization, consumer loyalty, privacy, and more.",
  description: ["Through our extensive survey analysis from business leaders and consumers alike, we\u2019ll take you on a journey through the most significant global trends in 2023. From the latest advancements in AI-powered personalization to the rising importance of consumer privacy, we\u2019ll explore the strategies and tactics businesses are using to connect with their customers on a deeper level.", "Continue reading for selected highlights from our research, or download the full report above."]
};

var Introduction = function Introduction() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionBase, {
    variant: "centered",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          variant: "h4",
          tag: "h2",
          children: Introduction_copy.heading
        }), Introduction_copy.description.map(function (paragraph, index) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Description, {
            variant: "pLarge",
            tag: "p",
            children: paragraph
          }, index);
        })]
      })
    })
  });
};

var StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e6gix5b1"
} : 0)(Section/* Wrapper */.im, "{grid-template-areas:'copy';grid-template-rows:auto;}" + ( true ? "" : 0));

var Description = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Description */.dk,  true ? {
  target: "e6gix5b0"
} : 0)( true ? {
  name: "3hgi0y",
  styles: "margin-top:32px"
} : 0);

/* harmony default export */ var Introduction_Introduction = (Introduction);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2023/components/KeyFindings/assets/StayingAheadOfTheCurve-xs.png
var StayingAheadOfTheCurve_xs = __webpack_require__(35642);
var StayingAheadOfTheCurve_xs_default = /*#__PURE__*/__webpack_require__.n(StayingAheadOfTheCurve_xs);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2023/components/KeyFindings/assets/StayingAheadOfTheCurve-xs.webp
var assets_StayingAheadOfTheCurve_xs = __webpack_require__(71596);
var assets_StayingAheadOfTheCurve_xs_default = /*#__PURE__*/__webpack_require__.n(assets_StayingAheadOfTheCurve_xs);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2023/components/KeyFindings/assets/StayingAheadOfTheCurve-xs@2x.png
var StayingAheadOfTheCurve_xs_2x = __webpack_require__(97727);
var StayingAheadOfTheCurve_xs_2x_default = /*#__PURE__*/__webpack_require__.n(StayingAheadOfTheCurve_xs_2x);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2023/components/KeyFindings/assets/StayingAheadOfTheCurve-xs@2x.webp
var assets_StayingAheadOfTheCurve_xs_2x = __webpack_require__(33487);
var assets_StayingAheadOfTheCurve_xs_2x_default = /*#__PURE__*/__webpack_require__.n(assets_StayingAheadOfTheCurve_xs_2x);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2023/components/KeyFindings/assets/StayingAheadOfTheCurve-sm.png
var StayingAheadOfTheCurve_sm = __webpack_require__(54444);
var StayingAheadOfTheCurve_sm_default = /*#__PURE__*/__webpack_require__.n(StayingAheadOfTheCurve_sm);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2023/components/KeyFindings/assets/StayingAheadOfTheCurve-sm.webp
var assets_StayingAheadOfTheCurve_sm = __webpack_require__(6026);
var assets_StayingAheadOfTheCurve_sm_default = /*#__PURE__*/__webpack_require__.n(assets_StayingAheadOfTheCurve_sm);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2023/components/KeyFindings/assets/StayingAheadOfTheCurve-sm@2x.png
var StayingAheadOfTheCurve_sm_2x = __webpack_require__(91132);
var StayingAheadOfTheCurve_sm_2x_default = /*#__PURE__*/__webpack_require__.n(StayingAheadOfTheCurve_sm_2x);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2023/components/KeyFindings/assets/StayingAheadOfTheCurve-sm@2x.webp
var assets_StayingAheadOfTheCurve_sm_2x = __webpack_require__(8434);
var assets_StayingAheadOfTheCurve_sm_2x_default = /*#__PURE__*/__webpack_require__.n(assets_StayingAheadOfTheCurve_sm_2x);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2023/components/KeyFindings/assets/WantToRetainCustomers-xs.png
var WantToRetainCustomers_xs = __webpack_require__(13007);
var WantToRetainCustomers_xs_default = /*#__PURE__*/__webpack_require__.n(WantToRetainCustomers_xs);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2023/components/KeyFindings/assets/WantToRetainCustomers-xs.webp
var assets_WantToRetainCustomers_xs = __webpack_require__(67314);
var assets_WantToRetainCustomers_xs_default = /*#__PURE__*/__webpack_require__.n(assets_WantToRetainCustomers_xs);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2023/components/KeyFindings/assets/WantToRetainCustomers-xs@2x.png
var WantToRetainCustomers_xs_2x = __webpack_require__(28022);
var WantToRetainCustomers_xs_2x_default = /*#__PURE__*/__webpack_require__.n(WantToRetainCustomers_xs_2x);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2023/components/KeyFindings/assets/WantToRetainCustomers-xs@2x.webp
var assets_WantToRetainCustomers_xs_2x = __webpack_require__(27761);
var assets_WantToRetainCustomers_xs_2x_default = /*#__PURE__*/__webpack_require__.n(assets_WantToRetainCustomers_xs_2x);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2023/components/KeyFindings/assets/WantToRetainCustomers-sm.png
var WantToRetainCustomers_sm = __webpack_require__(11907);
var WantToRetainCustomers_sm_default = /*#__PURE__*/__webpack_require__.n(WantToRetainCustomers_sm);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2023/components/KeyFindings/assets/WantToRetainCustomers-sm.webp
var assets_WantToRetainCustomers_sm = __webpack_require__(43233);
var assets_WantToRetainCustomers_sm_default = /*#__PURE__*/__webpack_require__.n(assets_WantToRetainCustomers_sm);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2023/components/KeyFindings/assets/WantToRetainCustomers-sm@2x.png
var WantToRetainCustomers_sm_2x = __webpack_require__(2790);
var WantToRetainCustomers_sm_2x_default = /*#__PURE__*/__webpack_require__.n(WantToRetainCustomers_sm_2x);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2023/components/KeyFindings/assets/WantToRetainCustomers-sm@2x.webp
var assets_WantToRetainCustomers_sm_2x = __webpack_require__(56130);
var assets_WantToRetainCustomers_sm_2x_default = /*#__PURE__*/__webpack_require__.n(assets_WantToRetainCustomers_sm_2x);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2023/components/KeyFindings/assets/ThePayoff-xs.png
var ThePayoff_xs = __webpack_require__(45104);
var ThePayoff_xs_default = /*#__PURE__*/__webpack_require__.n(ThePayoff_xs);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2023/components/KeyFindings/assets/ThePayoff-xs.webp
var assets_ThePayoff_xs = __webpack_require__(15984);
var assets_ThePayoff_xs_default = /*#__PURE__*/__webpack_require__.n(assets_ThePayoff_xs);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2023/components/KeyFindings/assets/ThePayoff-xs@2x.png
var ThePayoff_xs_2x = __webpack_require__(30867);
var ThePayoff_xs_2x_default = /*#__PURE__*/__webpack_require__.n(ThePayoff_xs_2x);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2023/components/KeyFindings/assets/ThePayoff-xs@2x.webp
var assets_ThePayoff_xs_2x = __webpack_require__(49166);
var assets_ThePayoff_xs_2x_default = /*#__PURE__*/__webpack_require__.n(assets_ThePayoff_xs_2x);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2023/components/KeyFindings/assets/ThePayoff-sm.png
var ThePayoff_sm = __webpack_require__(18815);
var ThePayoff_sm_default = /*#__PURE__*/__webpack_require__.n(ThePayoff_sm);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2023/components/KeyFindings/assets/ThePayoff-sm.webp
var assets_ThePayoff_sm = __webpack_require__(77716);
var assets_ThePayoff_sm_default = /*#__PURE__*/__webpack_require__.n(assets_ThePayoff_sm);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2023/components/KeyFindings/assets/ThePayoff-sm@2x.png
var ThePayoff_sm_2x = __webpack_require__(12570);
var ThePayoff_sm_2x_default = /*#__PURE__*/__webpack_require__.n(ThePayoff_sm_2x);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2023/components/KeyFindings/assets/ThePayoff-sm@2x.webp
var assets_ThePayoff_sm_2x = __webpack_require__(61715);
var assets_ThePayoff_sm_2x_default = /*#__PURE__*/__webpack_require__.n(assets_ThePayoff_sm_2x);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2023/components/KeyFindings/assets/AIAndML-xs.png
var AIAndML_xs = __webpack_require__(10242);
var AIAndML_xs_default = /*#__PURE__*/__webpack_require__.n(AIAndML_xs);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2023/components/KeyFindings/assets/AIAndML-xs.webp
var assets_AIAndML_xs = __webpack_require__(54363);
var assets_AIAndML_xs_default = /*#__PURE__*/__webpack_require__.n(assets_AIAndML_xs);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2023/components/KeyFindings/assets/AIAndML-xs@2x.png
var AIAndML_xs_2x = __webpack_require__(76924);
var AIAndML_xs_2x_default = /*#__PURE__*/__webpack_require__.n(AIAndML_xs_2x);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2023/components/KeyFindings/assets/AIAndML-xs@2x.webp
var assets_AIAndML_xs_2x = __webpack_require__(66744);
var assets_AIAndML_xs_2x_default = /*#__PURE__*/__webpack_require__.n(assets_AIAndML_xs_2x);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2023/components/KeyFindings/assets/AIAndML-sm.png
var AIAndML_sm = __webpack_require__(10631);
var AIAndML_sm_default = /*#__PURE__*/__webpack_require__.n(AIAndML_sm);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2023/components/KeyFindings/assets/AIAndML-sm.webp
var assets_AIAndML_sm = __webpack_require__(95924);
var assets_AIAndML_sm_default = /*#__PURE__*/__webpack_require__.n(assets_AIAndML_sm);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2023/components/KeyFindings/assets/AIAndML-sm@2x.png
var AIAndML_sm_2x = __webpack_require__(79200);
var AIAndML_sm_2x_default = /*#__PURE__*/__webpack_require__.n(AIAndML_sm_2x);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2023/components/KeyFindings/assets/AIAndML-sm@2x.webp
var assets_AIAndML_sm_2x = __webpack_require__(84703);
var assets_AIAndML_sm_2x_default = /*#__PURE__*/__webpack_require__.n(assets_AIAndML_sm_2x);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2023/components/KeyFindings/assets/Personalization-xs.png
var Personalization_xs = __webpack_require__(79569);
var Personalization_xs_default = /*#__PURE__*/__webpack_require__.n(Personalization_xs);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2023/components/KeyFindings/assets/Personalization-xs.webp
var assets_Personalization_xs = __webpack_require__(65687);
var assets_Personalization_xs_default = /*#__PURE__*/__webpack_require__.n(assets_Personalization_xs);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2023/components/KeyFindings/assets/Personalization-xs@2x.png
var Personalization_xs_2x = __webpack_require__(71338);
var Personalization_xs_2x_default = /*#__PURE__*/__webpack_require__.n(Personalization_xs_2x);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2023/components/KeyFindings/assets/Personalization-xs@2x.webp
var assets_Personalization_xs_2x = __webpack_require__(44887);
var assets_Personalization_xs_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Personalization_xs_2x);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2023/components/KeyFindings/assets/Personalization-sm.png
var Personalization_sm = __webpack_require__(34343);
var Personalization_sm_default = /*#__PURE__*/__webpack_require__.n(Personalization_sm);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2023/components/KeyFindings/assets/Personalization-sm.webp
var assets_Personalization_sm = __webpack_require__(60233);
var assets_Personalization_sm_default = /*#__PURE__*/__webpack_require__.n(assets_Personalization_sm);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2023/components/KeyFindings/assets/Personalization-sm@2x.png
var Personalization_sm_2x = __webpack_require__(9092);
var Personalization_sm_2x_default = /*#__PURE__*/__webpack_require__.n(Personalization_sm_2x);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2023/components/KeyFindings/assets/Personalization-sm@2x.webp
var assets_Personalization_sm_2x = __webpack_require__(43088);
var assets_Personalization_sm_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Personalization_sm_2x);
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2023/components/KeyFindings/data.ts








































var keyFindings = [{
  heading: "Staying ahead of the curve: Investing in personalization despite economic uncertainty",
  description: ["Despite economic uncertainty, it\u2019s encouraging to see that 69% of businesses we surveyed are increasing their investment in personalization.", "This suggests that businesses recognize the value of personalization in creating engaging and loyal customer relationships, even in tough times."],
  dataVisalization: {
    desktop: {
      pngSrc: (StayingAheadOfTheCurve_sm_default()),
      png2xSrc: (StayingAheadOfTheCurve_sm_2x_default()),
      webpSrc: (assets_StayingAheadOfTheCurve_sm_default()),
      webp2xSrc: (assets_StayingAheadOfTheCurve_sm_2x_default())
    },
    mobile: {
      pngSrc: (StayingAheadOfTheCurve_xs_default()),
      png2xSrc: (StayingAheadOfTheCurve_xs_2x_default()),
      webpSrc: (assets_StayingAheadOfTheCurve_xs_default()),
      webp2xSrc: (assets_StayingAheadOfTheCurve_xs_2x_default())
    },
    alt: "69% of business leaders are increasing their investment in personalization despite challenging economic headwinds."
  }
}, {
  heading: "Want to retain your customers? Keep it personal",
  description: ["Looking more closely at the value of personalization, it\u2019s clear why the majority of business leaders we surveyed are increasing their investment in this area.", "Our data shows that businesses are well aware of the benefits that personalization can offer, with the majority citing the ability to help retain current customers."],
  dataVisalization: {
    desktop: {
      pngSrc: (WantToRetainCustomers_sm_default()),
      png2xSrc: (WantToRetainCustomers_sm_2x_default()),
      webpSrc: (assets_WantToRetainCustomers_sm_default()),
      webp2xSrc: (assets_WantToRetainCustomers_sm_2x_default())
    },
    mobile: {
      pngSrc: (WantToRetainCustomers_xs_default()),
      png2xSrc: (WantToRetainCustomers_xs_2x_default()),
      webpSrc: (assets_WantToRetainCustomers_xs_default()),
      webp2xSrc: (assets_WantToRetainCustomers_xs_2x_default())
    },
    alt: "62% of business leaders cite improved customer retention as a benefit of personalization efforts."
  }
}, {
  heading: "The payoff: How investing in personalization delivers real returns",
  description: ["Once again our data shows that consumers want to feel like VIPs when they\u2019re interacting with businesses. Over half of consumers say they are more likely to make a repeat purchase after a personalized experience.", "Personalization is the new black in the business world \u2013 it\u2019s always in style. By tailoring experiences to their customers\u2019 needs and preferences, businesses can create a bond that\u2019s hard to break."],
  dataVisalization: {
    desktop: {
      pngSrc: (ThePayoff_sm_default()),
      png2xSrc: (ThePayoff_sm_2x_default()),
      webpSrc: (assets_ThePayoff_sm_default()),
      webp2xSrc: (assets_ThePayoff_sm_2x_default())
    },
    mobile: {
      pngSrc: (ThePayoff_xs_default()),
      png2xSrc: (ThePayoff_xs_2x_default()),
      webpSrc: (assets_ThePayoff_xs_default()),
      webp2xSrc: (assets_ThePayoff_xs_2x_default())
    },
    alt: "Over half (56%) of consumers say they will become repeat buyers after a personalized experience, a 7% increase year-over-year."
  }
}, {
  heading: "AI is driving next-level customer experiences",
  description: ["Reaching <a href=\"https://www.reuters.com/technology/chatgpt-sets-record-fastest-growing-user-base-analyst-note-2023-02-01/\">100 million daily active users</a> just two months after launch, Chat-GPT ushered in a craze for AI and machine learning (ML) \u2013 and it seems businesses have caught on.", "Our survey shows that organizations are increasingly adopting AI and machine learning to power their personalization efforts."],
  dataVisalization: {
    desktop: {
      pngSrc: (AIAndML_sm_default()),
      png2xSrc: (AIAndML_sm_2x_default()),
      webpSrc: (assets_AIAndML_sm_default()),
      webp2xSrc: (assets_AIAndML_sm_2x_default())
    },
    mobile: {
      pngSrc: (AIAndML_xs_default()),
      png2xSrc: (AIAndML_xs_2x_default()),
      webpSrc: (assets_AIAndML_xs_default()),
      webp2xSrc: (assets_AIAndML_xs_2x_default())
    },
    alt: "More than 9 in 10 companies (92%) are using AI-driven personalization to drive business growth."
  }
}, {
  heading: "Personalization in the age of privacy",
  description: ["It\u2019s no surprise that trust is becoming increasingly important when it comes to personalization efforts. With data breaches and privacy scandals making headlines all too often, consumers are understandably wary of giving away their personal information.", "But fear not, business leaders, there\u2019s still hope. By being transparent and respecting data privacy, brands can earn the trust of their customers and deliver personalized experiences that delight and inspire loyalty."],
  dataVisalization: {
    desktop: {
      pngSrc: (Personalization_sm_default()),
      png2xSrc: (Personalization_sm_2x_default()),
      webpSrc: (assets_Personalization_sm_default()),
      webp2xSrc: (assets_Personalization_sm_2x_default())
    },
    mobile: {
      pngSrc: (Personalization_xs_default()),
      png2xSrc: (Personalization_xs_2x_default()),
      webpSrc: (assets_Personalization_xs_default()),
      webp2xSrc: (assets_Personalization_xs_2x_default())
    },
    alt: "Just half (51%) of consumers trust brands to keep their personal data secure and use it responsibly."
  }
}];
/* harmony default export */ var data = (keyFindings);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/sanitize-html/index.js
var sanitize_html = __webpack_require__(24330);
var sanitize_html_default = /*#__PURE__*/__webpack_require__.n(sanitize_html);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
// EXTERNAL MODULE: ../../libs/matcha/components/Divider/index.ts + 1 modules
var Divider = __webpack_require__(76305);
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2023/components/KeyFindings/DividerSection.tsx


function DividerSection_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





var DividerSection = function DividerSection() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DividerSection_StyledSectionBase, {
    variant: "noCopy",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledDivider, {})
    })
  });
};

var DividerSection_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1v0n5051"
} : 0)(Section/* Wrapper */.im, "{padding-top:0;padding-bottom:0;}" + ( true ? "" : 0));

var StyledDivider = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Divider/* default */.Z,  true ? {
  target: "e1v0n5050"
} : 0)( true ? {
  name: "172op4w",
  styles: "margin-top:0;margin-bottom:0"
} : 0);

/* harmony default export */ var KeyFindings_DividerSection = (DividerSection);
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2023/components/KeyFindings/KeyFindingSection.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function KeyFindingSection_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var mobileImageDimensions = {
  width: 327,
  height: 426
};
var desktopImageDimensions = {
  width: 640,
  height: 280
};

var KeyFindingSection = function KeyFindingSection(_ref2) {
  var _ref2$keyFinding = _ref2.keyFinding,
      heading = _ref2$keyFinding.heading,
      description = _ref2$keyFinding.description,
      _ref2$keyFinding$data = _ref2$keyFinding.dataVisalization,
      mobile = _ref2$keyFinding$data.mobile,
      desktop = _ref2$keyFinding$data.desktop,
      alt = _ref2$keyFinding$data.alt,
      _ref2$isLast = _ref2.isLast,
      isLast = _ref2$isLast === void 0 ? false : _ref2$isLast;
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(KeyFindingSection_StyledSectionBase, {
      variant: "2Col",
      isLast: isLast,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            variant: "h2",
            tag: "h2",
            children: heading
          }), description.map(function (paragraph, index) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(KeyFindingSection_Description, {
              variant: "pLarge",
              tag: "p",
              dangerouslySetInnerHTML: {
                __html: sanitize_html_default()(paragraph, {
                  allowedTags: ["a"]
                })
              }
            }, index);
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", _objectSpread({
            type: "image/webp",
            media: theme.breakpoints.up("sm", false),
            srcSet: "".concat(desktop.webpSrc, ", ").concat(desktop.webp2xSrc, " 2x")
          }, desktopImageDimensions)), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", _objectSpread({
            type: "image/png",
            media: theme.breakpoints.up("sm", false),
            srcSet: "".concat(desktop.pngSrc, ", ").concat(desktop.png2xSrc, " 2x")
          }, desktopImageDimensions)), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", _objectSpread({
            type: "image/webp",
            srcSet: "".concat(mobile.webpSrc, ", ").concat(mobile.webp2xSrc, " 2x")
          }, mobileImageDimensions)), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, _objectSpread(_objectSpread({}, mobileImageDimensions), {}, {
            src: mobile.png2xSrc,
            alt: alt,
            loading: "lazy"
          }))]
        })
      })]
    }), !isLast && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(KeyFindings_DividerSection, {})]
  });
};

var _ref =  true ? {
  name: "1t8kox4",
  styles: "padding-bottom:80px"
} : 0;

var KeyFindingSection_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e2a0mq01"
} : 0)(Section/* Wrapper */.im, "{", function (_ref3) {
  var isLast = _ref3.isLast;
  return isLast && _ref;
}, " ", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.up("xl");
}, "{column-gap:80px;}", function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.up("xxl");
}, "{grid-template-columns:min(560px, 50%) min(640px, 50%);}}" + ( true ? "" : 0));

var KeyFindingSection_Description = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Description */.dk,  true ? {
  target: "e2a0mq00"
} : 0)( true ? {
  name: "1vmmf63",
  styles: "&:not(:first-of-type){margin-top:32px;}"
} : 0);

/* harmony default export */ var KeyFindings_KeyFindingSection = (KeyFindingSection);
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2023/components/KeyFindings/KeyFindings.tsx






var KeyFindings = function KeyFindings() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(KeyFindings_Wrapper, {
    children: data.map(function (keyFinding, index) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react.Fragment, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(KeyFindings_KeyFindingSection, {
          keyFinding: keyFinding,
          isLast: index === data.length - 1
        }, index)
      }, index);
    })
  });
};

var KeyFindings_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ed1qhvz0"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.neutrals.white[100];
}, ";" + ( true ? "" : 0));

/* harmony default export */ var KeyFindings_KeyFindings = (KeyFindings);
// EXTERNAL MODULE: ../../libs/templates/Forms/DemoForm/index.ts + 4 modules
var DemoForm = __webpack_require__(92472);
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2023/components/WantToGetTheMost/WantToGetTheMost.tsx


function WantToGetTheMost_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






var WantToGetTheMost_copy = {
  heading: "Ready to transform your customer experience with personalization?",
  description: "Join the 25,000+ companies on the Segment platform today."
};
var WantToGetTheMost_form = {
  customFormIdentifier: "cnt-personalizationreport23-demo"
};

var WantToGetTheMost = function WantToGetTheMost() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(WantToGetTheMost_StyledSectionBase, {
    id: "get-most-out-of-customer-data",
    variant: "centered",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCopyHeading, {
          variant: "h2",
          tag: "h2",
          children: WantToGetTheMost_copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          children: WantToGetTheMost_copy.description
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionContents, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DemoForm/* default */.Z, {
        customFormIdentifier: WantToGetTheMost_form.customFormIdentifier,
        customTrackingType: WantToGetTheMost_form.customFormIdentifier
      })
    })]
  });
};

var WantToGetTheMost_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1nvq20u2"
} : 0)(Section/* Wrapper */.im, "{row-gap:40px;}" + ( true ? "" : 0));

var StyledCopyHeading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Heading */.X6,  true ? {
  target: "e1nvq20u1"
} : 0)( true ? {
  name: "837xmr",
  styles: "max-width:684px"
} : 0);

var SectionContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Contents */.AU,  true ? {
  target: "e1nvq20u0"
} : 0)( true ? {
  name: "1q0wkne",
  styles: "justify-content:center;display:flex;max-width:417px"
} : 0);

/* harmony default export */ var WantToGetTheMost_WantToGetTheMost = (WantToGetTheMost);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Card/index.ts + 31 modules
var Card = __webpack_require__(74881);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2023/components/RecommendedReading/assets/CdpReport2023.png
var CdpReport2023 = __webpack_require__(40631);
var CdpReport2023_default = /*#__PURE__*/__webpack_require__.n(CdpReport2023);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2023/components/RecommendedReading/assets/DigitalAdvertising.png
var DigitalAdvertising = __webpack_require__(71617);
var DigitalAdvertising_default = /*#__PURE__*/__webpack_require__.n(DigitalAdvertising);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2023/components/RecommendedReading/assets/CacGuide2023.png
var CacGuide2023 = __webpack_require__(54850);
var CacGuide2023_default = /*#__PURE__*/__webpack_require__.n(CacGuide2023);
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2023/components/RecommendedReading/RecommendedReading.tsx


function RecommendedReading_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }














var RecommendedReading_copy = {
  heading: "Recommended reading"
};
var URL_PARAMS = "utm_source=ebook&utm_medium=referral&utm_campaign=all_cnt_02-05-23-state-of-personalization-report-2023_4142023&utm_content=ebook";
var cards = [{
  image: (CdpReport2023_default()),
  title: "The Customer Data Platform Report 2023",
  description: "Our new Customer Data Platform Report analyzes real data from the Twilio Segment platform (nearly 12 trillion API calls to be exact) to examine the biggest digital trends happening in customer engagement.",
  url: "/the-cdp-report/",
  buttonText: "Download the report"
}, {
  image: (DigitalAdvertising_default()),
  title: "Digital Advertising in the Cookieless World",
  description: "Learn how to deliver personalized and more transparent experiences in the absence of third-party cookies.",
  url: "https://learn.segment.com/digital-advertising-in-the-cookieless-world/",
  buttonText: "Download the guide"
}, {
  image: (CacGuide2023_default()),
  title: "Customer Acquisition Cost (CAC): A Guide for 2023",
  description: "In this guide, we share the CAC formula and explain how to calculate it. Discover what makes a \"good\" CAC, how to determine an LTV:CAC ratio, and steps you can take to improve both metrics for long-term success.",
  url: "https://learn.segment.com/customer-acquisition-cost-cac-guide/",
  buttonText: "Download the guide"
}];

var RecommendedReading = function RecommendedReading() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
    variant: "centered",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading, {
        variant: "h2",
        tag: "h3",
        children: RecommendedReading_copy.heading
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledColumnTrack, {
        columns: 1,
        overrides: {
          md: 2,
          lg: 3
        },
        children: cards.map(function (card) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledCardBase, {
            href: (0,getAbsoluteUrl/* default */.Z)("".concat(card.url, "?").concat(URL_PARAMS), pageConfig),
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Image */.Ee, {
              alt: card.title,
              src: card.image,
              variant: "fill"
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* Body */.uT, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* Copy */.CK, {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Headline */.s0, {
                  children: card.title
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Description */.dk, {
                  children: card.description
                })]
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Action */.aU, {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
                  iconEnd: Common/* ChevronRightIcon */.XC,
                  children: card.buttonText
                })
              })]
            })]
          }, card.title);
        })
      })
    })]
  });
};

/* harmony default export */ var RecommendedReading_RecommendedReading = (RecommendedReading);

var Heading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e6ug6po2"
} : 0)( true ? {
  name: "ti75j2",
  styles: "margin:0"
} : 0);

var StyledColumnTrack = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ColumnTrack/* default */.Z,  true ? {
  target: "e6ug6po1"
} : 0)(function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("xl");
}, "{padding:0 80px;}" + ( true ? "" : 0));

var StyledCardBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Card/* default */.ZP,  true ? {
  target: "e6ug6po0"
} : 0)( true ? "" : 0);
// EXTERNAL MODULE: ./src/views/StateOfPersonalizationReport2023/assets/OgStateOfPersonalizationReport2023.png
var OgStateOfPersonalizationReport2023 = __webpack_require__(97117);
var OgStateOfPersonalizationReport2023_default = /*#__PURE__*/__webpack_require__.n(OgStateOfPersonalizationReport2023);
;// CONCATENATED MODULE: ./src/views/StateOfPersonalizationReport2023/StateOfPersonalizationReport2023.tsx















var StateOfPersonalizationReport2023 = function StateOfPersonalizationReport2023() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: "The State of Personalization Report 2023 | Twilio Segment",
      pageDescription: "The State of Personalization Report 2023, Twilio Segment\u2019s annual look at the latest trends in personalization, consumer loyalty, privacy, and more.",
      pageOG: (OgStateOfPersonalizationReport2023_default()),
      themeColor: theme.palette.neutrals.white[100],
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Hero, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Main, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Introduction_Introduction, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(KeyFindings_KeyFindings, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WantToGetTheMost_WantToGetTheMost, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RecommendedReading_RecommendedReading, {})]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterCompact/* default */.Z, {})]
  });
};

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "e1ysf7840"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.gray[10];
}, ";" + ( true ? "" : 0));

/* harmony default export */ var StateOfPersonalizationReport2023_StateOfPersonalizationReport2023 = (StateOfPersonalizationReport2023);
;// CONCATENATED MODULE: ./src/pages/state-of-personalization-report/index.tsx



var StateOfPersonalizationReport = function StateOfPersonalizationReport() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StateOfPersonalizationReport2023_StateOfPersonalizationReport2023, {});
};

/* harmony default export */ var state_of_personalization_report = (StateOfPersonalizationReport);

/***/ }),

/***/ 56052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Layout__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Layout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6372);


/***/ }),

/***/ 90226:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/state-of-personalization-report",
      function () {
        return __webpack_require__(12878);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 97117:
/***/ (function(module) {

module.exports = "/_next/static/images/OgStateOfPersonalizationReport2023-0bdd7d61da6a23b2db316cf6766de28d.png";

/***/ }),

/***/ 49767:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero@2x-ecc1976ec8043945ac0525ac0e35aec9.png";

/***/ }),

/***/ 10631:
/***/ (function(module) {

module.exports = "/_next/static/images/AIAndML-sm-36733af5689a69fd3231dd112648ce04.png";

/***/ }),

/***/ 79200:
/***/ (function(module) {

module.exports = "/_next/static/images/AIAndML-sm@2x-a957ca3ac5803262a3ffc43bf01364a5.png";

/***/ }),

/***/ 10242:
/***/ (function(module) {

module.exports = "/_next/static/images/AIAndML-xs-4975be4450fc29a025949182b7572b06.png";

/***/ }),

/***/ 76924:
/***/ (function(module) {

module.exports = "/_next/static/images/AIAndML-xs@2x-ca86e663b795c84038d585840aab3480.png";

/***/ }),

/***/ 34343:
/***/ (function(module) {

module.exports = "/_next/static/images/Personalization-sm-03d922a4064c0dc95064cdcf772dc3a5.png";

/***/ }),

/***/ 9092:
/***/ (function(module) {

module.exports = "/_next/static/images/Personalization-sm@2x-9d19b512736046831de7ec6ac2e43913.png";

/***/ }),

/***/ 79569:
/***/ (function(module) {

module.exports = "/_next/static/images/Personalization-xs-4a642349017463267c5ac3c5c9be015f.png";

/***/ }),

/***/ 71338:
/***/ (function(module) {

module.exports = "/_next/static/images/Personalization-xs@2x-ad66699cb9e13cda0c1cc0c5ec30e605.png";

/***/ }),

/***/ 54444:
/***/ (function(module) {

module.exports = "/_next/static/images/StayingAheadOfTheCurve-sm-1c307a9be484fbd036eaf55a8c694ea0.png";

/***/ }),

/***/ 91132:
/***/ (function(module) {

module.exports = "/_next/static/images/StayingAheadOfTheCurve-sm@2x-88a0a214baf61bea50910fe2bd257517.png";

/***/ }),

/***/ 35642:
/***/ (function(module) {

module.exports = "/_next/static/images/StayingAheadOfTheCurve-xs-e5abdac8aea271ea4d26411f8b6b5114.png";

/***/ }),

/***/ 97727:
/***/ (function(module) {

module.exports = "/_next/static/images/StayingAheadOfTheCurve-xs@2x-74fc6f946a6f067759f1078360d225bc.png";

/***/ }),

/***/ 18815:
/***/ (function(module) {

module.exports = "/_next/static/images/ThePayoff-sm-5158d68aaac1ed95497d415c50f5aba1.png";

/***/ }),

/***/ 12570:
/***/ (function(module) {

module.exports = "/_next/static/images/ThePayoff-sm@2x-07280b171820dad36acd05f5209fd87c.png";

/***/ }),

/***/ 45104:
/***/ (function(module) {

module.exports = "/_next/static/images/ThePayoff-xs-35fad3c609d239453e3ad378d431847d.png";

/***/ }),

/***/ 30867:
/***/ (function(module) {

module.exports = "/_next/static/images/ThePayoff-xs@2x-af645b475fcbbe7f88af385aa021e7b5.png";

/***/ }),

/***/ 11907:
/***/ (function(module) {

module.exports = "/_next/static/images/WantToRetainCustomers-sm-c2b31c298b2677315c496a9fc79c55b9.png";

/***/ }),

/***/ 2790:
/***/ (function(module) {

module.exports = "/_next/static/images/WantToRetainCustomers-sm@2x-e2f15a139826b0693fee9a0b64294468.png";

/***/ }),

/***/ 13007:
/***/ (function(module) {

module.exports = "/_next/static/images/WantToRetainCustomers-xs-a6fc51c573d65165e35538abb941bb0c.png";

/***/ }),

/***/ 28022:
/***/ (function(module) {

module.exports = "/_next/static/images/WantToRetainCustomers-xs@2x-5bce8a341eb47c4e556a93e47c54111b.png";

/***/ }),

/***/ 54850:
/***/ (function(module) {

module.exports = "/_next/static/images/CacGuide2023-8542fdfb4a02bda857e9d380b64b7881.png";

/***/ }),

/***/ 40631:
/***/ (function(module) {

module.exports = "/_next/static/images/CdpReport2023-67d71bf82e7975298fac5cd581c8ad5e.png";

/***/ }),

/***/ 71617:
/***/ (function(module) {

module.exports = "/_next/static/images/DigitalAdvertising-9498e1a69329570feae9cb1b566fedf7.png";

/***/ }),

/***/ 20799:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero-5b7ad5dc75b9b7279ae9e5df877b5031.webp";

/***/ }),

/***/ 79044:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero@2x-9a175b3b5324409dbbb44594215e122c.webp";

/***/ }),

/***/ 95924:
/***/ (function(module) {

module.exports = "/_next/static/images/AIAndML-sm-be44a5191ae00c359f14514dc3c1acac.webp";

/***/ }),

/***/ 84703:
/***/ (function(module) {

module.exports = "/_next/static/images/AIAndML-sm@2x-4cfd06ca24ebc8ddf9609914e4a63000.webp";

/***/ }),

/***/ 54363:
/***/ (function(module) {

module.exports = "/_next/static/images/AIAndML-xs-9c98d79a193ba42d6c8890aa562e32f6.webp";

/***/ }),

/***/ 66744:
/***/ (function(module) {

module.exports = "/_next/static/images/AIAndML-xs@2x-d13970107f2497e83caf7a034e3e2052.webp";

/***/ }),

/***/ 60233:
/***/ (function(module) {

module.exports = "/_next/static/images/Personalization-sm-a335aab16b5956ba9d33696087e9e0d3.webp";

/***/ }),

/***/ 43088:
/***/ (function(module) {

module.exports = "/_next/static/images/Personalization-sm@2x-dd4b1d97a5bde1b9fa30401efdce1cba.webp";

/***/ }),

/***/ 65687:
/***/ (function(module) {

module.exports = "/_next/static/images/Personalization-xs-a6539787cded8f0080ee528d58fd1f5c.webp";

/***/ }),

/***/ 44887:
/***/ (function(module) {

module.exports = "/_next/static/images/Personalization-xs@2x-f8e54a8e2fe447564b716e4737d09a7d.webp";

/***/ }),

/***/ 6026:
/***/ (function(module) {

module.exports = "/_next/static/images/StayingAheadOfTheCurve-sm-dfb19d91645db1db53324538f45cd6bf.webp";

/***/ }),

/***/ 8434:
/***/ (function(module) {

module.exports = "/_next/static/images/StayingAheadOfTheCurve-sm@2x-5da72b2ebf14ff5e6e27fa3cca46027b.webp";

/***/ }),

/***/ 71596:
/***/ (function(module) {

module.exports = "/_next/static/images/StayingAheadOfTheCurve-xs-474a33185d75fe861045d52090d8030c.webp";

/***/ }),

/***/ 33487:
/***/ (function(module) {

module.exports = "/_next/static/images/StayingAheadOfTheCurve-xs@2x-8da48cd8585297f526ef36670cff0a0c.webp";

/***/ }),

/***/ 77716:
/***/ (function(module) {

module.exports = "/_next/static/images/ThePayoff-sm-f0dc9f158e2015217b267168340cc8ff.webp";

/***/ }),

/***/ 61715:
/***/ (function(module) {

module.exports = "/_next/static/images/ThePayoff-sm@2x-fac2872182556bd5c4e6ed1eb03c71ec.webp";

/***/ }),

/***/ 15984:
/***/ (function(module) {

module.exports = "/_next/static/images/ThePayoff-xs-b63d7ca200ae09112fb98627e4a84337.webp";

/***/ }),

/***/ 49166:
/***/ (function(module) {

module.exports = "/_next/static/images/ThePayoff-xs@2x-72b588d57ebc77e105e930bed9f0cfd4.webp";

/***/ }),

/***/ 43233:
/***/ (function(module) {

module.exports = "/_next/static/images/WantToRetainCustomers-sm-42ab85ff0e25fa424137eec35129b720.webp";

/***/ }),

/***/ 56130:
/***/ (function(module) {

module.exports = "/_next/static/images/WantToRetainCustomers-sm@2x-fb53c866542ccbce4cb0d24a54fd8619.webp";

/***/ }),

/***/ 67314:
/***/ (function(module) {

module.exports = "/_next/static/images/WantToRetainCustomers-xs-53f1669c846a6b3230316fd6bdc73acc.webp";

/***/ }),

/***/ 27761:
/***/ (function(module) {

module.exports = "/_next/static/images/WantToRetainCustomers-xs@2x-1f212308d7a603431fb930850a53eb77.webp";

/***/ }),

/***/ 76527:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 96969:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 32232:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 24195:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,9097,6577,3607,9137,3254,9129,8834,4330,1382,4136,2073,8392,5735,2429,7303,948,3996,7947,7960,6012,4881,9524,2472,9774,2888,179], function() { return __webpack_exec__(90226); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);